$(window).on('load resize',function () {
    var  h = $("#contents").height();
    $("#menu-box").css("min-height", h + "px");
});